import React, { Component } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import './button.scss';

class Button extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    type: PropTypes.oneOf([
      'grey',
      'blue',
      'green',
      'red',
      'transparent',
      'red-transparent',
      'black-white',
      'custom',
    ]),
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.element,
      PropTypes.func,
      PropTypes.string,
    ]).isRequired,
    disabled: PropTypes.bool,
    transitionConfig: PropTypes.object,
    isBlock: PropTypes.bool,
  };

  static defaultProps = {
    type: 'grey',
  };

  constructor(props) {
    super(props);
    this.getTypeClasses = this.getTypeClasses.bind(this);
  }

  getTypeClasses() {
    let textColor = 'text-black';
    let bgColor = 'bg-almostWhite';

    switch (this.props.type) {
      case 'blue':
        textColor = 'text-blue';
        bgColor = 'bg-lightBlue';
        break;
      case 'green':
        textColor = 'text-green';
        bgColor = 'bg-lightGreen';
        break;
      case 'red':
        textColor = 'text-red';
        bgColor = 'bg-lightRed';
        break;
      case 'transparent':
        bgColor = 'bg-transparent';
        break;
      case 'red-transparent':
        textColor = 'text-red';
        bgColor = 'bg-transparent';
        break;
      case 'black-white':
        bgColor = 'bg-white';
        break;
      case 'custom':
        return '';
      default:
        break;
    }

    return `${textColor} ${bgColor}`;
  }

  shouldComponentUpdate(nextProps) {
    const primitiveProps = ['type', 'className', 'disabled', 'onClick'];
    const hasAnyPrimitivePropChanged = primitiveProps.some(
      propName => this.props[propName] !== nextProps[propName]
    );
    if (hasAnyPrimitivePropChanged) {
      return true;
    }

    if (
      typeof this.props.children !== 'string' ||
      this.props.children !== nextProps.children
    ) {
      return true;
    }

    return false;
  }

  render() {
    return (
      <motion.button
        {...this.props}
        {...this.props.transitionConfig}
        disabled={this.props.disabled}
        onClick={this.props.onClick}
        className={cx(
          'btn font-medium text-sm border-none rounded px-4 outline-none',
          this.getTypeClasses(),
          this.props.className,
          {
            'pointer-events-none': this.props.disabled,
            block: this.props.isBlock,
          }
        )}>
        {this.props.children}
      </motion.button>
    );
  }
}

export default  Button;
